/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_StatusInputs */

const en_subscription_status = /** @type {(inputs: Subscription_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription Status`)
};

const fr_subscription_status = /** @type {(inputs: Subscription_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statut d’abonnement`)
};

const de_subscription_status = /** @type {(inputs: Subscription_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnementstatus`)
};

const it_subscription_status = /** @type {(inputs: Subscription_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stato dell'abbonamento`)
};

const ru_subscription_status = /** @type {(inputs: Subscription_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статус подписки`)
};

const es_subscription_status = /** @type {(inputs: Subscription_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado de suscripción`)
};

const zh_cn2_subscription_status = /** @type {(inputs: Subscription_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订阅状态`)
};

const ja_subscription_status = /** @type {(inputs: Subscription_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプションステータス`)
};

const hi_subscription_status = /** @type {(inputs: Subscription_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सदस्यता स्थिति`)
};

const pt_pt2_subscription_status = /** @type {(inputs: Subscription_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status da assinatura`)
};

/**
* | output |
* | --- |
* | "Subscription Status" |
*
* @param {Subscription_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subscription_status = /** @type {((inputs?: Subscription_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subscription_status(inputs)
	if (locale === "de") return de_subscription_status(inputs)
	if (locale === "it") return it_subscription_status(inputs)
	if (locale === "ru") return ru_subscription_status(inputs)
	if (locale === "es") return es_subscription_status(inputs)
	if (locale === "zh-CN") return zh_cn2_subscription_status(inputs)
	if (locale === "ja") return ja_subscription_status(inputs)
	if (locale === "hi") return hi_subscription_status(inputs)
	if (locale === "pt-PT") return pt_pt2_subscription_status(inputs)
	return en_subscription_status(inputs)
});